import { Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { MsalService } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { AvatarModule } from 'primeng/avatar';
import { UserService } from '../../shared/services/user.service';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-header-top',
  standalone: true,
  imports: [ RouterLink, RouterLinkActive, AvatarModule ,MatIconModule],
  templateUrl: './header-top.component.html',
  styleUrl: './header-top.component.scss'
})
export class HeaderTopComponent implements OnInit{
  fullNameIntials:string='';
  userRole:any;
  platform:any;
  odinROleFlag:boolean=false;
  constructor(
    public authService: AuthService,
    private router: Router,
    private msal: MsalService,
    private userService: UserService,
    private measurementsDataService: MeasurementsDataService) {}

    ngOnInit(): void {
      this.userRole=null;
      this.platform=null;
      this.userService.getProfile()
    .subscribe(profile => {
      this.authService.loggedInUser.set(profile);
      if(profile){
        this.userRole=profile?.portalRoles;
        this.platform=profile?.subscribedPlatforms;
        localStorage.setItem("role",this.userRole);
        localStorage.setItem("platform",this.platform);
      }
      if(this.platform.indexOf('ODIN') > -1){
        this.odinROleFlag=true;
      }
      this.fullNameIntials=(profile.firstName + ' ' + profile.lastName).trim();
      if(profile?.measurementSystem) this.measurementsDataService.setData(profile?.measurementSystem);
    });
    }

  get initials() {
    // const userDataInitails = this.authService.loggedInUser();
    // console.log("userdata",userDataInitails)
    // let fllName=''u
    // if (userDataInitails.firstName) {
    //   fullName= (userDataInitails.firstName + ' ' + userDataInitails.lastName).trim();
    // }else{
    //   fullName= this.username?.substring(0, this.username.indexOf('@')) || 'User';
    // }
    
    

    return this.fullNameIntials 
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  }

  get fullName() {
    const userData = this.authService.loggedInUser();    
    if (userData.firstName) {
      return (userData.firstName + ' ' + userData.lastName).trim();
    }
    
    return this.username?.substring(0, this.username.indexOf('@')) || 'User';
  }

  get username() {
    return this.msal.instance.getActiveAccount()?.username ?? '';
  }

  login() {
    this.msal.loginRedirect({redirectStartPage: '/'} as RedirectRequest);
  }

  logout() {
    this.msal.instance.logout();
  }

  isOnLoginRoute(): boolean {
    return this.router.url === '/login';
  }

  isOnDemoRoute(): boolean {
    return this.router.url === '/demo';
  }
}
